import { CaretIcon } from "components/page-components/Icons/small"
import React from "react"

export const TableHeadingSorter = ({
  attribute,
  heading,
  set_current_notice_slice,
  sort_by_attribute,
  sort_by,
}) => {
  const use_sort = () => {
    set_current_notice_slice(0)
    sort_by_attribute(attribute)
  }
  return (
    <th className="is-clickable title is-8" onClick={use_sort}>
      {heading}
      <span className="ml-2">
        <CaretIcon
          {...{
            size: 0.8,
            color: sort_by.attribute === attribute ? "#034055" : "#7aa0ad",
            rotation:
              sort_by.attribute === attribute && sort_by.order ? "up" : "down",
          }}
        />
      </span>
    </th>
  )
}
